<panel class="no-padding table-panel">
    <div class="spinner" *ngIf="retrievingInspectionResults">
      <mat-spinner diameter="30"></mat-spinner>
    </div>
    <table class="table table--full-width table--striped table--hover table--sortable" *ngIf="!retrievingInspectionResults">
      <thead>
        <tr>
          <!-- <th (click)="sortBy('Eval')" style="text-align: center" >{{'Eval' | translate | async}}</th>
          <th (click)="sortBy('InspectionDate')" width="130px"  >{{'Inspection Date' | translate | async}}</th>
          <th (click)="sortBy('Jobsite')" width="130px">{{'Inspector' | translate | async}}</th>
          <th (click)="sortBy('SerialNumber')" width="130px">{{'Serial Number' | translate | async}}</th>
          <th (click)="sortBy('SerialNumber')" width="130px">{{'Unit Number' | translate | async}}</th>
          <th (click)="sortBy('AddiUnitNumber')" width="130px">{{'Additional Unit Number' | translate | async}}</th>
          <th (click)="sortBy('Customer')" width="130px">{{'Customer' | translate | async}}</th>
          <th (click)="sortBy('Jobsite')" width="130px">{{'Job Site' | translate | async}}</th>
          <th (click)="sortBy('Make')" width="130px">{{'Make' | translate | async}}</th>
          <th (click)="sortBy('Model')" width="130px">{{'Model' | translate | async}}</th>
          <th (click)="sortBy('Family')" width="130px">{{'Family' | translate | async}}</th> -->
          <th (click)="sortBy('Eval')" style="text-align: center" width="100px">
            <span class="header-with-icon">
              {{'Eval' | translate | async}}
              <i class="material-icons sort-icon" *ngIf="evalOrder.selected">arrow_upward</i>
              <i class="material-icons sort-icon" *ngIf="!evalOrder.selected">arrow_downward</i>
            </span>
          <!-- <span class="header-with-icon">
            {{'Eval' | translate | async}}
            <i class="material-icons sort-icon" *ngIf="evalOrder.selected">arrow_upward</i>
            <i class="material-icons sort-icon" *ngIf="!evalOrder.selected">arrow_downward</i>
          </span> -->
        </th>

        <th (click)="sortBy('InspectionDate')" >
          <span class="header-with-icon">
            {{'Inspection Date' | translate | async}}
            <i class="material-icons sort-icon" *ngIf="dateOrder.selected">arrow_upward</i>
            <i class="material-icons sort-icon" *ngIf="!dateOrder.selected">arrow_downward</i>
          </span>
        </th>

        <th (click)="sortBy('Jobsite')" >
          <span class="header-with-icon">
            {{'Inspector' | translate | async}}
            <i class="material-icons sort-icon" *ngIf="uitOrder.selected">arrow_upward</i>
            <i class="material-icons sort-icon" *ngIf="!uitOrder.selected">arrow_downward</i>
          </span>
        </th>

        <th (click)="sortBy('SerialNumber')" >
          <span class="header-with-icon">
            {{'Serial Number' | translate | async}}
            <i class="material-icons sort-icon" *ngIf="serialOrder.selected">arrow_upward</i>
            <i class="material-icons sort-icon" *ngIf="!serialOrder.selected">arrow_downward</i>
          </span>
        </th>

        <th (click)="sortBy('SerialNumber')" >
          <span class="header-with-icon">
            {{'Unit Number' | translate | async}}
            <i class="material-icons sort-icon" *ngIf="serialOrder.selected">arrow_upward</i>
            <i class="material-icons sort-icon" *ngIf="!serialOrder.selected">arrow_downward</i>
          </span>
        </th>

        <th (click)="sortBy('AddiUnitNumber')" >
          <span class="header-with-icon">
            {{'Additional Unit Number' | translate | async}}
            <i class="material-icons sort-icon" *ngIf="addiunitOrder.selected">arrow_upward</i>
            <i class="material-icons sort-icon" *ngIf="!addiunitOrder.selected">arrow_downward</i>
          </span>
        </th>

        <th (click)="sortBy('Customer')" >
          <span class="header-with-icon">
            {{'Customer' | translate | async}}
            <i class="material-icons sort-icon" *ngIf="customerOrder.selected">arrow_upward</i>
            <i class="material-icons sort-icon" *ngIf="!customerOrder.selected">arrow_downward</i>
          </span>
        </th>

        <th (click)="sortBy('Jobsite')" >
          <span class="header-with-icon">
            {{'Job Site' | translate | async}}
            <i class="material-icons sort-icon" *ngIf="jobsiteOrder.selected">arrow_upward</i>
            <i class="material-icons sort-icon" *ngIf="!jobsiteOrder.selected">arrow_downward</i>
          </span>
        </th>

        <th (click)="sortBy('Make')" >
          <span class="header-with-icon">
            {{'Make' | translate | async}}
            <i class="material-icons sort-icon" *ngIf="makeOrder.selected">arrow_upward</i>
            <i class="material-icons sort-icon" *ngIf="!makeOrder.selected">arrow_downward</i>
          </span>
        </th>

        <th (click)="sortBy('Model')" >
          <span class="header-with-icon">
            {{'Model' | translate | async}}
            <i class="material-icons sort-icon" *ngIf="modelOrder.selected">arrow_upward</i>
            <i class="material-icons sort-icon" *ngIf="!modelOrder.selected">arrow_downward</i>
          </span>
        </th>

        <th (click)="sortBy('Family')" >
          <span class="header-with-icon">
            {{'Family' | translate | async}}
            <i class="material-icons sort-icon" *ngIf="familyOrder.selected">arrow_upward</i>
            <i class="material-icons sort-icon" *ngIf="!familyOrder.selected">arrow_downward</i>
          </span>
        </th>
        </tr>
      </thead>
      <tbody>
        <tr *ngFor="let inspection of inspectionResults">
          <td class="no-padding" (click)="openInspection(inspection)"  [@fadeIn] style="text-align: center">
            <span class="eval {{getEval(inspection.Eval) | lowercase}}" >{{getEvalVal(inspection.Eval)}}</span>
          </td>
          <td   (click)="openInspection(inspection)" [@fadeIn]>{{inspection.InspectionDate | date:'dd/MMM/yyyy'}}</td>
          <td   (click)="openInspection(inspection)" [@fadeIn] [attr.title]="inspection.Examiner">{{inspection.Examiner}}</td>
          <td   (click)="openInspection(inspection)" [@fadeIn] [attr.title]="inspection.SerialNumber">{{inspection.SerialNumber}}</td>
          <td   (click)="openInspection(inspection)" [@fadeIn] [attr.title]="inspection.UnitNumber">{{inspection.UnitNumber}}</td>
          <td   (click)="openInspection(inspection)" [@fadeIn] [attr.title]="inspection.AddiUnitNumber">{{inspection.AddiUnitNumber}}</td>
          <td   (click)="openInspection(inspection)" [@fadeIn] [attr.title]="inspection.CustomerName">{{inspection.CustomerName}}</td>
          <td   (click)="openInspection(inspection)" [@fadeIn] [attr.title]="inspection.JobsiteName">{{inspection.JobsiteName}}</td>
          <td   (click)="openInspection(inspection)" [@fadeIn] [attr.title]="inspection.Make">{{inspection.Make}}</td>
          <td   (click)="openInspection(inspection)" [@fadeIn] [attr.title]="inspection.Model">{{inspection.Model}}</td>
          <td   (click)="openInspection(inspection)" [@fadeIn] [attr.title]="inspection.Family">{{inspection.Family}}</td>
        </tr>
        <!-- <app-temperature-list-row *ngFor="let i of equipmentInspectionResults" [EQnInspectionIds]="i"></app-temperature-list-row> -->
      </tbody>
    </table>
    <mat-paginator [pageIndex]="pageNumber"
                   [length]="totalResults"
                   [pageSize]="inspectionsPerPage"
                   [pageSizeOptions]="[5, 10, 25, 100]"
                   (page)="onPageEvent($event)">
    </mat-paginator>
  </panel>